'use strict';

module.exports = function(ModalService) {
  return {
    restrict: 'E',
    templateUrl: '/app/modules/calendar/CalendarListView.html?v=4.5.6',
    scope: {
      dates: '=',
    },
    controller: function($scope) {
      $scope.concatedDates = [];

      console.log($scope.dates);

      _.forEach($scope.dates, function(date) {
        var appointments = [];

        if (appointments.length > 0) {
          $scope.concatedDates.push({
            date: date.date,
            appointments: appointments,
          });
        }
      });

      $scope.openAppointment = function(appointment) {
        ModalService.openAppointmentModal(appointment);
      };

      $scope.dateHaveAppointments = function(date) {
        var count = 0;

        _.forEach(date.resources, function(resource) {
          count += _.size(resource.appointments);
        });

        return count > 0;
      };
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/modules/calendar/calendarListDirective.js